export default __webpack_public_path__ + "static/media/product-files.a0f6f010.svg";